// istanbul ignore file
/* eslint-disable */
// ignore lint and test rules since this is a slightly altered ARIA SDK and will be replaced with the current third party version by Work Item 348115

import {
  Int64,
  IBondSerializable,
  IProtocolWriter,
  IProtocolReader
} from "../lib/microsoft.bond";
import { BondDataType } from "../lib/bond-const";
import { Map } from "../lib/microsoft.bond.collections";

//------------------------------------------------------------------------------
//     This code was generated by using the bondc tool and modified to remove
//      deserialization because it is unused.
//
//     Tool     : bondc, Version=3.0.1, Build=bond-git.debug.not
//     Template : Microsoft.Bond.Rules.dll#TypeScript.tt
//     File     : DataPackage.ts
//
//     Changes to this file may cause incorrect behavior and will be lost when
//     the code is regenerated.
//------------------------------------------------------------------------------

export class utils {
  static GetGuid(): string {
    var rd = function() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1, 5);
    };
    return [
      rd(),
      rd(),
      "-",
      rd(),
      "-",
      rd(),
      "-",
      rd(),
      "-",
      rd(),
      rd(),
      rd()
    ].join("");
  }

  static GetTimeStamp(): Int64 {
    var val = new Date().getTime();
    var timestamp = new Int64("0");
    timestamp.low = val & 0xffffffff;
    timestamp.high = Math.floor(val / 0x100000000);
    return timestamp;
  }

  static GetTimeStampWithValue(timestamp: number): Int64 {
    var bond_timestamp = new Int64("0");
    bond_timestamp.low = timestamp & 0xffffffff;
    bond_timestamp.high = Math.floor(timestamp / 0x100000000);
    return bond_timestamp;
  }
}

export enum RecordType {
  NotSet = 0,
  Event = 1,
  // Deprecated, please use PerformanceCounterAzure and PerformanceCounterGfs instead
  PerformanceCounter = 2,
  Anomaly = 3,
  Prediction = 4,
  TraceLog = 5,
  EventSourceLog = 6,
  HttpLog = 7,
  PerformanceCounterAzure = 8,
  PerformanceCounterGfs = 9
}

export enum PIIScrubber {
  NotSet = 0,
  O365 = 1,
  SkypeBI = 2,
  SkypeData = 3
}

export enum PIIKind {
  NotSet = 0,
  DistinguishedName = 1,
  GenericData = 2,
  IPV4Address = 3,
  IPv6Address = 4,
  MailSubject = 5,
  PhoneNumber = 6,
  QueryString = 7,
  SipAddress = 8,
  SmtpAddress = 9,
  Identity = 10,
  Uri = 11,
  Fqdn = 12,

  // Supports scrubbing of the last octet in a IPV4 address. E.g. 10.121.227.147 becomes 10.121.227.*
  IPV4AddressLegacy = 13,

  // To scrub file path where it doesn't begin with file: | http: | https: | ftp: etc. known naming conventions
  FilePath = 14
}

export class PII implements IBondSerializable {
  // 1: optional PIIScrubber ScrubType
  ScrubType: PIIScrubber = PIIScrubber.NotSet;

  // 2: optional PIIKind Kind
  Kind: PIIKind = PIIKind.NotSet;

  // 3: optional string RawContent
  RawContent: string = "";

  Write(writer: IProtocolWriter): void {
    this.WriteImpl(writer, false /*isBase*/);
  }

  WriteImpl(writer: IProtocolWriter, isBase: boolean): void {
    writer.WriteStructBegin(null /*metadata*/, isBase);

    if (this.ScrubType != PIIScrubber.NotSet) {
      writer.WriteFieldBegin(BondDataType.BT_INT32, 1, null);
      writer.WriteInt32(this.ScrubType);
      writer.WriteFieldEnd();
    } else {
      writer.WriteFieldOmitted(BondDataType.BT_INT32, 1, null);
    }
    if (this.Kind != PIIKind.NotSet) {
      writer.WriteFieldBegin(BondDataType.BT_INT32, 2, null);
      writer.WriteInt32(this.Kind);
      writer.WriteFieldEnd();
    } else {
      writer.WriteFieldOmitted(BondDataType.BT_INT32, 2, null);
    }
    if (this.RawContent != "") {
      writer.WriteFieldBegin(BondDataType.BT_STRING, 3, null);
      writer.WriteString(this.RawContent);
      writer.WriteFieldEnd();
    } else {
      writer.WriteFieldOmitted(BondDataType.BT_STRING, 3, null);
    }
    writer.WriteStructEnd(isBase);
  }

  Read(reader: IProtocolReader): void {
    this.ReadImpl(reader, false /*isBase*/);
  }

  // @ts-ignore
  ReadImpl(reader: IProtocolReader, isBase: boolean): void {}
}

export class Record implements IBondSerializable {
  // 1: optional string Id
  Id: string = utils.GetGuid();

  // 3: optional int64 Timestamp
  Timestamp: Int64 = utils.GetTimeStamp();

  // 5: optional string Type
  Type: string = "";

  // 6: optional string EventType
  EventType: string = "";

  // 13: optional map<string, string> Extension
  Extension: Map<string, string> = new Map<string, string>();

  // 24: optional RecordType RecordType
  RecordType: RecordType = RecordType.NotSet;

  // 30: optional map<string, PII> PIIExtensions
  PIIExtensions: Map<string, PII> = new Map<string, PII>();

  AddOrReplacePII(key: string, piiValue: string, piiKind: PIIKind): void {
    var pii = new PII();
    pii.RawContent = piiValue;
    pii.Kind = piiKind;
    pii.ScrubType = PIIScrubber.O365;
    this.PIIExtensions.AddOrReplace(key, pii);
  }

  Write(writer: IProtocolWriter): void {
    this.WriteImpl(writer, false /*isBase*/);
  }

  WriteImpl(writer: IProtocolWriter, isBase: boolean): void {
    writer.WriteStructBegin(null /*metadata*/, isBase);

    if (this.Id != "") {
      writer.WriteFieldBegin(BondDataType.BT_STRING, 1, null);
      writer.WriteString(this.Id);
      writer.WriteFieldEnd();
    } else {
      writer.WriteFieldOmitted(BondDataType.BT_STRING, 1, null);
    }
    if (!this.Timestamp.Equals("0")) {
      writer.WriteFieldBegin(BondDataType.BT_INT64, 3, null);
      writer.WriteInt64(this.Timestamp);
      writer.WriteFieldEnd();
    } else {
      writer.WriteFieldOmitted(BondDataType.BT_INT64, 3, null);
    }
    if (this.Type != "") {
      writer.WriteFieldBegin(BondDataType.BT_STRING, 5, null);
      writer.WriteString(this.Type);
      writer.WriteFieldEnd();
    } else {
      writer.WriteFieldOmitted(BondDataType.BT_STRING, 5, null);
    }
    if (this.EventType != "") {
      writer.WriteFieldBegin(BondDataType.BT_STRING, 6, null);
      writer.WriteString(this.EventType);
      writer.WriteFieldEnd();
    } else {
      writer.WriteFieldOmitted(BondDataType.BT_STRING, 6, null);
    }
    if (this.Extension.Count()) {
      writer.WriteFieldBegin(BondDataType.BT_MAP, 13, null);
      writer.WriteMapContainerBegin(
        this.Extension.Count(),
        BondDataType.BT_STRING,
        BondDataType.BT_STRING
      );
      for (var i8 = 0; i8 < this.Extension.GetBuffer().length; ++i8) {
        writer.WriteString(this.Extension.GetBuffer()[i8].Key!!!);
        writer.WriteString(this.Extension.GetBuffer()[i8].Value!!!);
      }
      writer.WriteContainerEnd();
      writer.WriteFieldEnd();
    } else {
      writer.WriteFieldOmitted(BondDataType.BT_MAP, 13, null);
    }
    if (this.RecordType != RecordType.NotSet) {
      writer.WriteFieldBegin(BondDataType.BT_INT32, 24, null);
      writer.WriteInt32(this.RecordType);
      writer.WriteFieldEnd();
    } else {
      writer.WriteFieldOmitted(BondDataType.BT_INT32, 24, null);
    }
    if (this.PIIExtensions.Count()) {
      writer.WriteFieldBegin(BondDataType.BT_MAP, 30, null);
      writer.WriteMapContainerBegin(
        this.PIIExtensions.Count(),
        BondDataType.BT_STRING,
        BondDataType.BT_STRUCT
      );
      for (var i66 = 0; i66 < this.PIIExtensions.GetBuffer().length; ++i66) {
        writer.WriteString(this.PIIExtensions.GetBuffer()[i66].Key!!!);
        this.PIIExtensions.GetBuffer()[i66].Value!!!.WriteImpl(writer, false);
      }
      writer.WriteContainerEnd();
      writer.WriteFieldEnd();
    } else {
      writer.WriteFieldOmitted(BondDataType.BT_MAP, 30, null);
    }
    writer.WriteStructEnd(isBase);
  }

  Read(reader: IProtocolReader): void {
    this.ReadImpl(reader, false /*isBase*/);
  }

  // @ts-ignore
  ReadImpl(reader: IProtocolReader, isBase: boolean): void {}
}

export class DataPackage implements IBondSerializable {
  // 2: optional string Source
  Source: string = "";

  // 5: optional string DataPackageId
  DataPackageId: string = "";

  // 6: optional int64 Timestamp
  Timestamp: Int64 = new Int64("0");

  // 8: optional vector<clienttelemetry.data.v1.Record> Records
  Records: Record[] = [];

  Write(writer: IProtocolWriter): void {
    this.WriteImpl(writer, false /*isBase*/);
  }

  WriteImpl(writer: IProtocolWriter, isBase: boolean): void {
    writer.WriteStructBegin(null /*metadata*/, isBase);

    if (this.Source != "") {
      writer.WriteFieldBegin(BondDataType.BT_STRING, 2, null);
      writer.WriteString(this.Source);
      writer.WriteFieldEnd();
    } else {
      writer.WriteFieldOmitted(BondDataType.BT_STRING, 2, null);
    }
    if (this.DataPackageId != "") {
      writer.WriteFieldBegin(BondDataType.BT_STRING, 5, null);
      writer.WriteString(this.DataPackageId);
      writer.WriteFieldEnd();
    } else {
      writer.WriteFieldOmitted(BondDataType.BT_STRING, 5, null);
    }
    if (!this.Timestamp.Equals("0")) {
      writer.WriteFieldBegin(BondDataType.BT_INT64, 6, null);
      writer.WriteInt64(this.Timestamp);
      writer.WriteFieldEnd();
    } else {
      writer.WriteFieldOmitted(BondDataType.BT_INT64, 6, null);
    }
    if (this.Records.length) {
      writer.WriteFieldBegin(BondDataType.BT_LIST, 8, null);
      writer.WriteContainerBegin(this.Records.length, BondDataType.BT_STRUCT);
      for (var i52 = 0; i52 < this.Records.length; ++i52) {
        this.Records[i52].WriteImpl(writer, false);
      }
      writer.WriteContainerEnd();
      writer.WriteFieldEnd();
    } else {
      writer.WriteFieldOmitted(BondDataType.BT_LIST, 8, null);
    }
    writer.WriteStructEnd(isBase);
  }

  Read(reader: IProtocolReader): void {
    this.ReadImpl(reader, false /*isBase*/);
  }

  // @ts-ignore
  ReadImpl(reader: IProtocolReader, isBase: boolean): void {}
}

export class ClientToCollectorRequest implements IBondSerializable {
  // 1: optional vector<clienttelemetry.data.v1.DataPackage> DataPackages
  DataPackages: DataPackage[] = [];

  // 2: optional int32 RequestRetryCount
  RequestRetryCount: number = 0;

  Write(writer: IProtocolWriter): void {
    this.WriteImpl(writer, false /*isBase*/);
  }

  WriteImpl(writer: IProtocolWriter, isBase: boolean): void {
    writer.WriteStructBegin(null /*metadata*/, isBase);

    if (this.DataPackages.length) {
      writer.WriteFieldBegin(BondDataType.BT_LIST, 1, null);
      writer.WriteContainerBegin(
        this.DataPackages.length,
        BondDataType.BT_STRUCT
      );
      for (var i67 = 0; i67 < this.DataPackages.length; ++i67) {
        this.DataPackages[i67].WriteImpl(writer, false);
      }
      writer.WriteContainerEnd();
      writer.WriteFieldEnd();
    } else {
      writer.WriteFieldOmitted(BondDataType.BT_LIST, 1, null);
    }
    if (this.RequestRetryCount != 0) {
      writer.WriteFieldBegin(BondDataType.BT_INT32, 2, null);
      writer.WriteInt32(this.RequestRetryCount);
      writer.WriteFieldEnd();
    } else {
      writer.WriteFieldOmitted(BondDataType.BT_INT32, 2, null);
    }
    writer.WriteStructEnd(isBase);
  }

  Read(reader: IProtocolReader): void {
    this.ReadImpl(reader, false /*isBase*/);
  }

  // @ts-ignore
  ReadImpl(reader: IProtocolReader, isBase: boolean): void {}
}
